import apiClient from '../config/api';
import { getWorkshopId } from '../config/constants';

const resolveWorkshopId = (workshopId) => {
    const effectiveWorkshopId = workshopId || getWorkshopId();

    if (!effectiveWorkshopId) {
        throw new Error('Taller no seleccionado');
    }

    return effectiveWorkshopId;
};

export const employeeService = {
    async getEmployees(workshopId) {
        const resolvedWorkshopId = resolveWorkshopId(workshopId);
        const response = await apiClient.get(`/workshops/all/employees/${resolvedWorkshopId}`);
        // Retorna array de empleados con _id del API
        return response.data;
    },

    async createEmployee(workshopId, employeeData) {
        const resolvedWorkshopId = resolveWorkshopId(workshopId);
        const payload = {
            workshop_id: resolvedWorkshopId,
            employee: employeeData,
        };

        console.log('Payload enviado al API:', JSON.stringify(payload, null, 2));
        const response = await apiClient.post('/workshops/employee', payload);
        return response.data;
    },

    async updateEmployee(employeeId, employeeData) {
        if (!employeeId) {
            throw new Error('Empleado no seleccionado');
        }

        const payload = {
            user_id: employeeId,
            params: employeeData,
        };

        const response = await apiClient.put(`/users/${employeeId}`, payload);
        return response.data;
    },

    async deleteEmployee(employeeId) {
        if (!employeeId) {
            throw new Error('Empleado no seleccionado');
        }

        const payload = {
            user_id: employeeId,
            params: { is_deleted: 1 },
        };

        const response = await apiClient.put(`/users/${employeeId}`, payload);
        return response.data;
    },
};
